import { connectRefinementList } from 'instantsearch.js/es/connectors';

/**
 * Creates a Popular Categories widget that shows a curated subset
 * of techTransferMainTopic facet values with counts and toggle behavior.
 * Uses connectRefinementList so it shares state with the Main Topic widget.
 */
export function createPopularCategories(
  containerSelector = '[data-popular-categories]',
) {
  const container = document.querySelector(containerSelector);
  if (!container) return null;

  const popularTitles = JSON.parse(container.dataset.popularTitles || '[]');
  if (!popularTitles.length) return null;

  let isOpen = true;

  // Build the static shell once
  container.innerHTML = `
        <button type="button" class="popular-header flex w-full flex-row justify-between rounded-sm px-2 py-1 mb-2 hover:bg-gray-200 cursor-pointer">
            <div class="font-bold">Popular Categories</div>
            <div>
                <svg class="popular-arrow ml-1 transform text-gray-600 transition-transform rotate-180" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.59 9.09L12 13.67L7.41 9.09L6 10.5L12 16.5L18 10.5L16.59 9.09Z" fill="currentColor"></path>
                </svg>
            </div>
        </button>
        <div class="popular-body space-y-2"></div>
    `;

  const header = container.querySelector('.popular-header');
  const arrow = container.querySelector('.popular-arrow');
  const body = container.querySelector('.popular-body');

  header.addEventListener('click', () => {
    isOpen = !isOpen;
    body.style.display = isOpen ? '' : 'none';
    arrow.classList.toggle('rotate-180', isOpen);
  });

  let currentRefine = null;

  return connectRefinementList(({ items, refine }, isFirstRender) => {
    currentRefine = refine;

    // Build a lookup from all available items
    const itemMap = new Map(items.map((item) => [item.label, item]));

    // Render only the curated popular items, in CMS order
    body.innerHTML = popularTitles
      .map((title) => {
        const item = itemMap.get(title);
        const count = item ? item.count : 0;
        const isRefined = item ? item.isRefined : false;
        if (count === 0 && !isRefined) return '';

        return `
                <label class="flex items-center rounded-sm px-2 py-1 hover:bg-gray-200 cursor-pointer" data-value="${title}">
                    <input type="checkbox" class="cursor-pointer text-black focus:ring-primary" ${isRefined ? 'checked' : ''}>
                    <span class="ml-2 text-sm font-medium leading-5">${title}
                        <span class="ml-2 inline-flex items-center rounded-full bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700 ring-1 ring-inset ring-gray-700/20">${count}</span>
                    </span>
                </label>
            `;
      })
      .join('');

    // Attach click handlers
    body.querySelectorAll('label[data-value]').forEach((label) => {
      label.addEventListener('click', (e) => {
        e.preventDefault();
        if (currentRefine) {
          currentRefine(label.dataset.value);
        }
      });
    });
  })({
    attribute: 'techTransferMainTopic',
  });
}
